// extracted by mini-css-extract-plugin
export default {"modal":"EditCrewMemberModal_modal__Rl0og","halfWidth":"EditCrewMemberModal_halfWidth__NK-l3","descriptionLabel":"EditCrewMemberModal_descriptionLabel__QU+nz"};